import React, { useState } from "react";
/* Styles */
import "./HomeView.css";
/* Constants */
import { FULL_NAME, JOB_DESCRIPTION, AVATAR_PATH } from "../../db/myAboutMe";
/* Subcomponents */
import { ExternalLinks } from "../../components";
import AnimatedText from "../../components/AnimatedText/AnimatedText";

const HomeView = () => {
  const [firstName, lastName] = FULL_NAME.split(" ");
  const [avatarLoaded, setAvatarLoaded] = useState(false);

  return (
    <section className="HomeView__">
      {/* name */}
      <div className="HomeView__fullName">
        <AnimatedText>
          <span className="HomeView__firstName">{firstName}</span>{" "}
          <span className="HomeView__lastName">{lastName}</span>
        </AnimatedText>
      </div>

      {/* job title */}
      <h2 className="HomeView__description">{JOB_DESCRIPTION}</h2>

      <div className="HomeView__selfIntro">
        {/* avatar */}
        <span className="HomeView__avatar-container">
          {!avatarLoaded && <span className="HomeView__avatar-skeleton" />}

          <img
            className={`HomeView__avatar ${
              !avatarLoaded ? "HomeView__avatar--hidden" : ""
            }`}
            src={AVATAR_PATH}
            alt="my avatar"
            onLoad={() => setAvatarLoaded(true)}
          />
        </span>

        {/* about me */}
        <div>
          <p>
            I'm a Vancouver-based Software Developer with 6+ years of experience
            specializing in building customer-facing applications, e-commerce
            systems, and full-stack products at startups and Amazon.
          </p>

          <p>
            I have extensive experience optimizing the purchase funnel through
            experimentation and A/B testing to improve conversion and revenue.
          </p>

          <p>
            At Amazon and in startup environments, I worked on large-scale
            customer-facing features used by thousands of users, with a strong
            focus on performance, usability, and measurable business impact.
          </p>

          <p>
            As a solo engineer, I built and launched TrackLoop, a platform that
            helps dancers and directors manage routines, loop songs, share
            projects through QR codes, and sync across devices with
            offline-first support. See it here:{" "}
            <a href="https://info.track-loop.app">TrackLoop</a>
          </p>

          <p>
            My primary stack includes TypeScript, React, Node.js, and Next.js,
            along with experience in Java, Golang, AWS, Stripe, Postgres,
            DynamoDB, GraphQL, and CI/CD pipelines.
          </p>

          <p>
            I enjoy owning features end-to-end, from backend architecture and
            APIs to frontend implementation, deployment, analytics, and
            monitoring.
          </p>
        </div>
      </div>

      {/* link to github, resume etc */}
      <ExternalLinks />

      {/* current employer, learning, etc */}
      {/* <h2 className="section-title">My Status</h2>
      <CurrentStatus /> */}
    </section>
  );
};

export default HomeView;
